import React, { useEffect } from "react";
import "./Header.css";
import "./Home.css";
import { Link } from "react-router-dom";

const Header = ({ onMenuOpen, isMenuOpen, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "auto";
  }, [isMenuOpen]);

  return (
    <header className="med-header">
      <div className="container">
        <div className="med-navbar">
          {/* LOGO */}
          <div className="med-logo">
            <img src="/assets/img/logo/Jeevandaan Logo.png" alt="Medicax" />
          </div>

          {/* DESKTOP MENU */}

          <ul className="med-menu">
            <li>
              <Link className="link" to="/">
                Home <i className="fa-solid fa-angle-down"></i>
              </Link>
            </li>
            <li>
              <Link className="link" to="/about">
                About Us <i className="fa-solid fa-angle-down"></i>
              </Link>
            </li>
            <li>
              <Link className="link" to="/services">
                Services <i className="fa-solid fa-angle-down"></i>
              </Link>
            </li>
            <li>
              <Link className="link" to="/contact">
                Contact Us <i className="fa-solid fa-angle-down"></i>
              </Link>
            </li>
            <li>
              <Link className="link" to="/career">
                Career <i className="fa-solid fa-angle-down"></i>
              </Link>
            </li>
          </ul>

          {/* RIGHT */}
          <div className="med-right">
            <button className="med-btn d-none d-md-inline-flex">
              Schedule an Appointment
              <i className="fa-solid fa-arrow-right"></i>
            </button>

            {/* MOBILE TOGGLE */}
            <div className="vl-header-action-item d-block d-lg-none">
              <button
                type="button"
                onClick={onMenuOpen}
                className="vl-offcanvas-toggle"
              >
                <i className="fa-solid fa-bars-staggered" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* OVERLAY */}
      {isMenuOpen && (
        <div className="vl-offcanvas-overlay" onClick={onClose}></div>
      )}
    </header>
  );
};

export default Header;
